import React from 'react';

const Location = ({ address }) => {
  return (
    <div>
      <h3>Location</h3>
      <iframe
        src={`https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`}
        width="100%"
        height="250"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        title="Business Location"
      />
    </div>
  );
};

export default Location;
